import makeService from './api';

export default makeService('macro_types');
